import { loadData } from "./dataLoader";

let origin;

loadData("arcanas.json").then((data) => (origin = data));

const getArcanaById = (id) => origin.find((e) => e.id === id);
const getArcanaByName = (lang, name) => origin.find((e) => e.name[lang] === name);

export { getArcanaById, getArcanaByName };
